<div class="grid grid-cols-12 gap-2">

  <mat-form-field appearance="outline" class="col-span-12" floatLabel="always" subscriptSizing="dynamic">
    <mat-label>{{label}} {{ required ? "*" : "" }}</mat-label>
    <input matInput type="text" [placeholder]="'Search ' + label " [disabled]="disabled" [(ngModel)]="searchText"
      (ngModelChange)="filterTexts($event)" [matAutocomplete]="auto" #autoTrigger="matAutocompleteTrigger" subs />
    <ng-container matSuffix>
      <mat-progress-spinner class="mr-[10px]" *ngIf="isLoading" diameter="18" mode="indeterminate" strokeWidth="1" color="primary"> </mat-progress-spinner>

      <mat-icon *ngIf="!isLoading">search</mat-icon>
    </ng-container>


    <mat-autocomplete panelClass="autocomplete-with-sticky-add" [hideSingleSelectionIndicator]="true" #auto="matAutocomplete" [displayWith]="displayText"
      (optionSelected)="onSelectSelectedText($event.option.value)">
      <mat-option (click)="openAddSelectedTextDialog()" class="sticky-add-option text-blue-500">+ Add new text</mat-option>
      <mat-option *ngFor="let text of filteredTexts" [value]="text"
        class="auto-complete-with-icon flex items-center justify-between w-full">

        <div class="option-wrapper" >
          <span class="text">{{ text.value }}</span>

          <button mat-icon-button class="delete-btn" (click)="deleteText(text, $event);">
            <mat-icon class="!m-0 !p-0">delete</mat-icon>
          </button>
        </div>

      </mat-option>
    </mat-autocomplete>
  </mat-form-field>


</div>
